<template>
  <div id="app">
    <div id="particles-js"></div>
    <ToastModal></ToastModal>
    <ConfirmModal></ConfirmModal>
    <router-view/>
  </div>
</template>

<script>
import ToastModal from '@/components/ToastModal.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'

export default {
  components: {
    ToastModal,
    ConfirmModal
  },
  mounted() {
    if (typeof window === 'undefined' || typeof window.particlesJS !== 'function') {
      console.warn('particles.js failed to load, skip background animation')
      return
    }

    window.particlesJS('particles-js', {
      particles: {
        number: { value: 80, density: { enable: true, value_area: 800 } },
        color: { value: '#FFFFFF' },
        shape: { type: 'circle' },
        opacity: { value: 0.7, random: true },
        size: { value: 3, random: true },
        line_linked: {
          enable: true,
          distance: 150,
          color: '#FFFFFF',
          opacity: 0.4,
          width: 1
        },
        move: {
          enable: true,
          speed: 1,
          direction: 'none',
          random: true,
          straight: false,
          out_mode: 'out',
          bounce: false
        }
      },
      interactivity: {
        detect_on: 'canvas',
        events: {
          onhover: { enable: true, mode: 'grab' },
          onclick: { enable: true, mode: 'push' },
          resize: true
        },
        modes: {
          grab: { distance: 140, line_linked: { opacity: 0.6 } },
          push: { particles_nb: 4 }
        }
      },
      retina_detect: true
    })
  }
}
</script>

<style lang="css" scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  min-height: 100vh;
  overflow: auto;
  background-color: #1D2129;
  background-image:
    linear-gradient(rgba(22, 93, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 93, 255, 0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  color: white;
}

#particles-js {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  opacity: 0.5;
}
</style>
